import React, { FunctionComponent, useEffect, useState } from 'react';
import {
  AuthGate,
  AuthServiceProvider,
  fetchConfig
} from '@trp-ta-nitro/auth-react';
import AppContainerSpinner from './AppContainerSpinner';
import { RouteComponentProps } from 'react-router';
import App from './App';
import mockConfig from '../config.json';

type options = {
  apiKey: string;
  types: {
    external: {};
  };
};

const AuthApp: FunctionComponent<RouteComponentProps> = (props) => {
  const [options, setOptions] = useState<options | undefined>(undefined);
  const [config, setConfig] = useState<ApplicationConfig | undefined>(
    undefined
  );

  const [isConfigLoading, setIsConfigLoading] = useState<boolean>(true);

  useEffect(() => {
    const basePath = window.location.origin;
    const appContext = 'personal-investing/tools/pamwebsite';
    const configPathList: string[] = [
      `${basePath}/${appContext}/config.json?hash=${Date.now()}`
    ];

    const fetchOptions = async () => {
      const response = await fetchConfig<ApplicationConfig>(configPathList);
      setConfig(response);
      setIsConfigLoading(false);
      const options = {
        apiKey: response && response.apiKey ? response.apiKey : '',
        types: {
          external: {}
        }
      };
      setOptions(options);
    };
    fetchOptions().catch(console.error);
  }, []);

  return process.env.NODE_ENV === 'development' ? (
    <App {...props} config={mockConfig} />
  ) : isConfigLoading || !config || !options ? (
    <AppContainerSpinner />
  ) : (
    <AuthServiceProvider options={options}>
      <AuthGate>
        <App {...props} config={config} />
      </AuthGate>
    </AuthServiceProvider>
  );
};

export default AuthApp;
